import "./Pilot.module.css";
import Navigation from "@/reusable_sections/Header";
import Conversation from "./sections/Conversation";
import Faq from "./sections/Faq";
import Commitment from "./sections/Commitment";
import Footer from "@/reusable_sections/Footer";
export default function PilotPage() {
  return <div>
      <Navigation />
      <Conversation />
      <Faq />
      <Commitment />
      <Footer />
    </div>;
}